import { render, staticRenderFns } from "./addBrand.vue?vue&type=template&id=ae959572&scoped=true&"
import script from "./addBrand.vue?vue&type=script&lang=js&"
export * from "./addBrand.vue?vue&type=script&lang=js&"
import style0 from "./addBrand.vue?vue&type=style&index=0&id=ae959572&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae959572",
  null
  
)

export default component.exports